







































































































































































































































































































































declare var dataLayer: any;
import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Header: () => import("@/components/Jobs/Common/Header.vue"),
    FiltersBar: () => import("@/components/filtersbar/FiltersBar.vue"),
    OfferInfo: () => import("@/components/Jobs/Common/OfferInfo.vue"),
    Compatibility: () => import("@/components/Compatibility.vue"),
    Postulate: () => import("@/components/postulation/Postulate.vue"),
    Footer: () => import("@/components/Jobs/Homepage/Footer.vue"),
    PostulationQuick: () =>
      import("@/components/postulation/PostulationQuick.vue")
  }
})
export default class SearchResults extends Vue {
  offersSearch = [];
  selectedTab = 0;
  sort: string = "";
  countFilter = {};
  selectedArea = "";
  selectedLocation = "";
  position_word = "";
  filtersWord = [];
  loading = true;
  filterFields = {
    time: 0,
    is_part_time: 0,
    is_full_time: 0,
    is_remote: 0,
    is_temporal: 0,
    experiences: [],
    area: {},
    location: {},
    search_word: {}
  };
  options = [
    {
      name: "Últimas 24hs",
      tag: "time",
      value: "1"
    },
    {
      name: "Última semana",
      tag: "time",
      value: "2"
    },
    {
      name: "Último mes",
      tag: "time",
      value: "3"
    },
    {
      name: "Full time",
      tag: "is_full_time"
    },
    {
      name: "Part time",
      tag: "is_part_time"
    },
    {
      name: "Remoto",
      tag: "is_remote"
    },
    {
      name: "Temporal",
      tag: "is_temporal"
    }
  ];
  shareModal = false;
  favorite = false;
  link_social = "";
  withIdOffer = false;
  CDestinoPublic = "";

  async mounted() {
    await (this as any).mountedOffer();
    (this as any).link_social = window.location.origin;
    if ((this as any).$route.query.quick) {
      (this as any).openModal((this as any).offersSearch[0]);
      (window as any).history.pushState(
        "",
        "",
        (window as any).location.pathname
      );
    }
  }

  async mountedOffer() {
    let response = {
      data: []
    };
    if ((this as any).$route.name === "SearchResults Buenos Aires") {
      (this as any).loading = true;
      response = await (this as any).$root._post("offer/all", {
        provinceId: 1410
      });
      (this as any).loading = false;
    } else if ((this as any).$route.name === "SearchResults Argentina") {
      (this as any).loading = true;
      response = await (this as any).$root._post("offer/all", {
        countryId: 1122
      });
      (this as any).loading = false;
    } else if ((this as any).$route.name === "Offer with id") {
      let id = (this as any).$route.params.id;
      (this as any).loading = true;
      response = await (this as any).$root._get("offer/one/" + id, {});
      (this as any).loading = false;
      (this as any).withIdOffer = true;
    } else if ((this as any).$route.name === "Search Results With Parameters") {
      (this as any).loading = true;
      await (this as any).processWord((this as any).$route.params.word);
      await (this as any).processArea();
      await (this as any).processLocation();
      await (this as any).processAvailability();
      await (this as any).processExperience();
      await (this as any).getOffersByFilter();
      (this as any).loading = false;
    } else if ((this as any).$route.name === "Offer with area and location") {
      (this as any).loading = true;
      if (isNaN((this as any).$route.params.area)) {
        await (this as any).processWord((this as any).$route.params.area);
      } else {
        await (this as any).processArea();
      }
      await (this as any).processLocation();
      await (this as any).getOffersByFilter();
      (this as any).loading = false;
    } else if ((this as any).$route.name === "SearchResults Jobs") {
      this.CDestinoPublic = "JOBS";
      response = await (this as any).$root._post("offer/all", {
        c_destino_publi: this.CDestinoPublic
      });
    } else if ((this as any).$route.name === "SearchResults Bmo") {
      this.CDestinoPublic = "BMO";
      response = await (this as any).$root._post("offer/all", {
        c_destino_publi: this.CDestinoPublic
      });
    } else if ((this as any).$route.name === "SearchResults Bayint") {
      this.CDestinoPublic = "BAYINT";
      response = await (this as any).$root._post("offer/all", {
        c_destino_publi: this.CDestinoPublic
      });
    } else if ((this as any).$route.name === "SearchResults Prof") {
      this.CDestinoPublic = "PROF";
      response = await (this as any).$root._post("offer/all", {
        c_destino_publi: this.CDestinoPublic
      });
    } else if ((this as any).$route.name === "SearchResults Nucint") {
      this.CDestinoPublic = "NUCINT";
      response = await (this as any).$root._post("offer/all", {
        c_destino_publi: this.CDestinoPublic
      });
    } else {
      (this as any).loading = true;
      await this.getOffersByFilter();
      let newOffer = (this as any).offersSearch;

      let offers: any = [];
      if (newOffer.length) {
        for (let i: number = 0; i < newOffer.length; i++) {
          offers.push({
            ...newOffer[i],
            hover: false,
            network: false
          });
        }
        (this as any).offersSearch = offers;
      }
      (this as any).loading = false;
    }
    if (response && response.data && response.data.length) {
      (this as any).offersSearch = response.data;
    }
  }

  async processExperience() {
    if ((this as any).$route.params.experience !== "-") {
      let experience = (this as any).$root.experiences.find(
        (e: any) => e.id === (this as any).$route.params.experience
      );
      this.setFilters({
        name: (this as any).$root.config.experiences[experience.id],
        tag: "experiences",
        value: experience.id
      });
    }
  }

  async processLocation() {
    if ((this as any).$route.params.location !== "-") {
      const response = await (this as any).$root._get(
        "nucleus_types/one/" + (this as any).$route.params.location,
        {}
      );
      (this as any).filtersWord.push({
        value: (this as any).$route.params.location,
        name: response.description,
        tag: "location"
      });
      (this as any).selectedLocation = {
        value: (this as any).$route.params.location,
        name: response.description
      };
      (this as any).filterFields.location = {
        value: (this as any).$route.params.location,
        name: response.description,
        tag: "location"
      };
    }
  }

  async processWord(searchedWord: any) {
    if (searchedWord !== "-") {
      (this as any).filtersWord.push({
        name: searchedWord.replace(/-/g, " "),
        addTag: true,
        tag: "word"
      });
      (this as any).filterFields.search_word = {
        name: searchedWord.replace(/-/g, " "),
        addTag: true,
        tag: "word"
      };
    }
  }

  async processAvailability() {
    if ((this as any).$route.params.availability !== "-") {
      let availability = {};
      if ((this as any).$route.params.availability === "full-time") {
        availability = { name: "Full time", tag: "is_full_time" };
        (this as any).filterFields.is_full_time = 1;
      } else {
        if ((this as any).$route.params.availability === "part-time") {
          availability = { name: "Part time", tag: "is_part_time" };
          (this as any).filterFields.is_part_time = 1;
        } else {
          if ((this as any).$route.params.availability === "remoto") {
            availability = { name: "Remoto", tag: "is_remote" };
            (this as any).filterFields.is_remote = 1;
          } else {
            if ((this as any).$route.params.availability === "temporal") {
              availability = { name: "Temporal", tag: "is_temporal" };
              (this as any).filterFields.is_temporal = 1;
            }
          }
        }
      }
      if (Object.keys(availability).length) {
        (this as any).filtersWord.push(availability);
      }
    }
  }

  async processArea() {
    if ((this as any).$route.params.area !== "-") {
      const response = await (this as any).$root._get(
        "area/" + (this as any).$route.params.area,
        {}
      );
      if (response.data.length && response.data[0] !== null) {
        (this as any).filtersWord.push({
          value: (this as any).$route.params.area,
          name: response.data[0].description,
          tag: "area"
        });
        (this as any).selectedArea = {
          value: (this as any).$route.params.area,
          name: response.data[0].description
        };
        (this as any).filterFields.area = {
          value: (this as any).$route.params.area,
          name: response.data[0].description,
          tag: "area"
        };
      }
    }
  }

  async setFilters(filter: any) {
    if (filter.tag === "experiences") {
      if (
        (this as any).filtersWord.filter((element: any) => {
          return element.name === filter.name;
        }).length === 0
      ) {
        (this as any).filterFields.experiences.push(filter);
        (this as any).filtersWord.push(filter);
      }
    } else if (filter.tag === "area") {
      (this as any).filtersWord.filter((element: any, index: any) => {
        if ("area" === element.tag) (this as any).filtersWord.splice(index, 1);
      });
      (this as any).filtersWord.push(filter);
      (this as any).filterFields.area = filter;
    } else if (filter.tag === "location") {
      (this as any).filtersWord.filter((element: any, index: any) => {
        if ("location" === element.tag)
          (this as any).filtersWord.splice(index, 1);
      });
      (this as any).filtersWord.push(filter);
      (this as any).filterFields.location = filter;
    } else if (filter.tag === "word" || filter.addTag) {
      if (filter.name !== "") {
        (this as any).filtersWord.filter((element: any, index: any) => {
          if ("word" === element.tag)
            (this as any).filtersWord.splice(index, 1);
        });
        (this as any).filtersWord.push(filter);
        (this as any).filterFields.search_word = filter;
      } else {
        (this as any).filterFields.search_word = "";
        (this as any).filtersWord.filter((element: any, index: any) => {
          if ("word" === element.tag)
            (this as any).filtersWord.splice(index, 1);
        });
      }
    } else if (filter.tag === "time") {
      (this as any).filtersWord.filter((element: any, index: any) => {
        if ("time" === element.tag) (this as any).filtersWord.splice(index, 1);
      });
      if (filter.value === "1") {
        (this as any).filterFields["time"] = 1;
      } else if (filter.value === "2") {
        (this as any).filterFields["time"] = 7;
      } else (this as any).filterFields["time"] = moment().daysInMonth();

      (this as any).filtersWord.push(filter);
    } else if ((this as any).filterFields[filter.tag] === 0) {
      (this as any).filterFields[filter.tag] = 1;
      (this as any).filtersWord.push(filter);
    }
    (this as any).getOffersByFilter();
  }

  async setSort(opt: string) {
    (this as any).sort = opt;
    (this as any).getOffersByFilter();
  }

  async removeFilter(item: any) {
    if (item.tag === "experiences") {
      (this as any).filterFields.experiences.filter(
        (element: any, index: any) => {
          if (item.value === element.value) {
            (this as any).filterFields.experiences.splice(index, 1);
          }
        }
      );
      (this as any).filtersWord.filter((element: any, index: any) => {
        if (item.value === element.value) {
          (this as any).filtersWord.splice(index, 1);
        }
      });
    } else if (item.tag === "area") {
      (this as any).filterFields.area = "";
      (this as any).filtersWord.filter((element: any, index: any) => {
        if ("area" === element.tag) (this as any).filtersWord.splice(index, 1);
      });
    } else if (item.tag === "word" || item.addTag) {
      (this as any).filterFields.search_word = "";
      (this as any).filtersWord.filter((element: any, index: any) => {
        if ("word" === element.tag) (this as any).filtersWord.splice(index, 1);
      });
    } else if (item.tag === "time") {
      (this as any).filtersWord.filter((element: any, index: any) => {
        if ("time" === element.tag) (this as any).filtersWord.splice(index, 1);
      });
      (this as any).filterFields["time"] = 0;
    } else {
      (this as any).filterFields[item.tag] = 0;
      (this as any).filtersWord.filter((element: any, index: any) => {
        if (item.tag === element.tag)
          (this as any).filtersWord.splice(index, 1);
      });
    }
    (this as any).$router.push("/ofertas");
    (this as any).getOffersByFilter();
  }

  async getOffersByFilter() {
    let dates = [];
    let element = (this as any).filterFields.experiences.map((item: any) => {
      return item.value;
    });

    let payload: any = {};

    if ((this as any).filterFields.is_part_time) {
      payload["is_part_time"] = (this as any).filterFields.is_part_time;
    }

    if ((this as any).filterFields.is_full_time) {
      payload["is_full_time"] = (this as any).filterFields.is_full_time;
    }

    if ((this as any).filterFields.is_remote) {
      payload["is_remote"] = (this as any).filterFields.is_remote;
    }

    if ((this as any).filterFields.is_temporal) {
      payload["is_temporal"] = (this as any).filterFields.is_temporal;
    }

    if (element.length > 0) {
      payload["experience"] = '["'.concat(element.toString()).concat('"]');
    }

    if ((this as any).filterFields.time > 0) {
      payload["created_last_days"] = "["
        .concat((this as any).filterFields.time.toString())
        .concat("]");
    }

    if ((this as any).filterFields.area.tag) {
      payload["areaId"] = (this as any).filterFields.area.value.toString();
    }

    if ((this as any).filterFields.location.tag) {
      payload["cityId"] = (this as any).filterFields.location.value.toString();
    }

    if ((this as any).filterFields.search_word.name) {
      payload["search_word"] = (this as any).filterFields.search_word.name;
    }

    if (this.CDestinoPublic) {
      payload["c_destino_publi"] = this.CDestinoPublic;
    }

    const response = await (this as any).$root._post("offer/all", payload);
    (this as any).offersSearch = response.data;
  }

  areaSelect(item: any) {
    (this as any).selectedArea = item;
  }

  locationSelect(item: any) {
    (this as any).selectLocation = item;
  }

  setWord(word: any) {
    (this as any).position_word = word;
  }

  async removeAllFilter() {
    (this as any).filtersWord = [];
    (this as any).filterFields.time = 0;
    (this as any).filterFields.is_part_time = 0;
    (this as any).filterFields.is_full_time = 0;
    (this as any).filterFields.is_remote = 0;
    (this as any).filterFields.is_temporal = 0;
    (this as any).filterFields.experiences = [];
    delete (this as any).filterFields.area.name;
    delete (this as any).filterFields.area.tag;
    delete (this as any).filterFields.area.value;
    delete (this as any).filterFields.search_word.name;
    delete (this as any).filterFields.search_word.tag;

    await (this as any).getOffersByFilter();
  }

  updateSelected(tab: any, offer: any) {
    this.selectedTab = tab;
    (this as any).$store.commit(
      "setOffer",
      (this as any).offersSearch[this.selectedTab]
    );
    dataLayer.push({
      event: "VirtualPageview",
      virtualPageURL: `/oferta/${offer.id}`,
      virtualPageTitle: offer.title
    });
  }

  updateSelectedMobile(tab: any, offer: any) {
    if ((this as any).$root.isMobile) {
      this.$router.push("/oferta-detalle/" + tab);
      window.scrollTo(0, 0);
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: `/oferta/${offer.id}`,
        virtualPageTitle: offer.title
      });
    }
  }

  timestamp(tm: any) {
    let diff = Date.now() - tm;
    if (!diff) {
      return "";
    }

    let diffDays = Math.floor(diff / 86400000);
    let diffHrs = Math.floor((diff % 86400000) / 3600000);
    let diffMins = Math.round(((diff % 86400000) % 3600000) / 60000);

    if (diffDays > 0) {
      return diffDays === 1 ? diffDays + "day" : diffDays + "days";
    } else if (diffHrs > 0) {
      return diffHrs === 1 ? diffHrs + "hr" : diffHrs + "hrs";
    } else if (diffMins > 0) {
      return diffMins === 1 ? diffMins + "min" : diffMins + "mins";
    }
  }

  openModal(offer: any) {
    if ((this as any).$store.state.token) {
      let postulateComponent: any = (this as any).$children.find(
        (children: any) => {
          return children.$options._componentTag === "Postulate";
        }
      );
      postulateComponent.offerId = offer.id;
      postulateComponent.showModal();
    } else {
      let postulateComponent: any = (this as any).$children.find(
        (children: any) => {
          return children.$options._componentTag === "PostulationQuick";
        }
      );
      postulateComponent.offerId = offer.id;
      postulateComponent.showModal();
    }
  }

  async toggleOffer(offer: any) {
    let favValue = 1;

    if ((this as any).$store.state.token) {
      if (this.withIdOffer) {
        if (offer.favorite) {
          favValue = 0;
        }
      } else {
        if (offer.users.length > 0 && offer.users[0].users_offers) {
          if (offer.users[0].users_offers.favorite) {
            favValue = 0;
          }
        }
      }
      const response = await (this as any).$root._post("useroffer", {
        offerId: offer.id,
        favorite: favValue,
        postulate: this.withIdOffer
          ? offer.postulate
          : offer.users &&
            offer.users.length > 0 &&
            offer.users[0].users_offers &&
            offer.users[0].users_offers.postulate
          ? 1
          : 0
      });

      if (!this.withIdOffer) {
        (this as any).getOffersByFilter();
        (this as any).$root.reloadUser();
      }
    }
    this.mountedOffer();
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }
}
